<script>

import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import {mapActions, mapState} from "vuex";
import TextPage from "@/pages/MyOutLine/TextPage.vue";
import XTable from "@/components/XTable/index.vue";
import DateUtil from "@/utils/formatDate";

export default {
  name: "ConsultingManagement",
  components: {XTable, TextPage, AppBox, AppHeader},
  data() {
    return {
      maxHeight: 500,
      minHeight: 500,
      layout: "sizes, prev, pager, next",
      dialogTitle: "",
      dialogVisible: false,
      chatLogList: {},
      currentUserId: null,
      currentTime: Date.now(),
      currentPage: 1,
      defaultSize: 20,
      chatBoxLoading: false,
      replayInput: "",
      intervalId: null
    };
  },
  async mounted() {
    this.handleResize();

  },
  computed: {
    DateUtil() {
      return DateUtil
    },
    ...mapState("fuzhu", ["consultingList", "consultingListLoading"]),
    ...mapState("user", ["permissionCode"]),
    filter: {
      get() {
        return this.$store.state.fuzhu.consultingListFilter;
      },
      set(value) {
        this.$store.commit("fuzhu/setData", {
          key: "consultingListFilter",
          value,
        });
      },
    },
    columns: function () {
      const self = this;
      const columns = [
        {
          prop: "nickname",
          label: "昵称",
        },
        // {
        //   prop: "content",
        //   label: "消息内容",
        // },
        {
          prop: "needHuman",
          label: "待回复",
        },
        {
          label: "发送时间",
          render(h, scope) {
            return (
                <div>
                  <span>{self.formatDate(scope.row.createTime)}</span>
                </div>
            );
          },
        },
      ];
      if (this.permissionCode.has('assist:consulting:manager')) {
        columns.push({
          label: "操作",
          fixed: "right",
          width: 200,
          render(h, scope) {
            return (
                <div>
                  <el-button
                      onClick={() => {
                        self.handleReply(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    回复
                  </el-button>
                  <el-button
                      onClick={() => {
                        self.handleView(scope.row);
                      }}
                      size="mini"
                      type="primary"
                      plain
                  >
                    查看
                  </el-button>
                </div>
            );
          },
        })
      }
      return columns;
    }
  },
  methods: {
    ...mapActions("fuzhu", ["getUserChatLogOverview", "getChatLog", "answerConsulting"]),
    handleResize() {
      this.$nextTick(() => {
        const el = document.getElementById("appBox");
        if (el.offsetHeight <= 650) {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.56;
        } else {
          this.maxHeight = el.offsetHeight - el.offsetHeight * 0.35;
        }
      });
    },
    closeChatDialog() {
      clearInterval(this.intervalId);
      this.getUserChatLogOverview(this.consultingList)
    },
    handleReply(row) {
      this.dialogTitle = "回复";
      this.openChatDialog(row)
      let self = this;
      this.intervalId = setInterval(() => {
        self.requestAfterChatLog()
      }, 2000);
    },
    handleView(row) {
      this.dialogTitle = "查看";
      this.openChatDialog(row)
    },

    openChatDialog(row) {
      let self = this;
      this.currentUserId = row.userId;
      this.dialogVisible = true;
      if (!this.chatLogList[row.userId]) {
        this.requestBeforeChatLog((data) => {
          self.scrollToEnd()
        })
      }
      this.$nextTick(() => {
        const elementById = document.getElementById("chat-box");
        elementById.addEventListener("scroll", this.handleScrollEnd, true);
      })
    },

    requestBeforeChatLog(call) {
      if (this.chatBoxLoading) return;
      this.chatBoxLoading = true
      let userId = this.currentUserId;
      let size = this.defaultSize;
      let page = 1;

      let chatLog = this.chatLogList[userId];

      let beforeTime;
      if (chatLog?.length) {
        beforeTime = chatLog[0].createTime;
      } else {
        chatLog = []
        beforeTime = Date.now();
      }

      this.getChatLog({userId, beforeTime, page, size})
          .then(data => {
            let reverse = data.reverse()
            this.$set(this.chatLogList, userId, [...reverse, ...chatLog])
            this.chatBoxLoading = false
            call && call(data)
          });

    },
    requestAfterChatLog(call) {
      if (this.chatBoxLoading) return;
      this.chatBoxLoading = true
      let userId = this.currentUserId;
      let size = this.defaultSize;
      let page = null;

      let chatLog = this.chatLogList[userId];

      let afterTime;
      if (chatLog?.length) {
        afterTime = chatLog[chatLog.length - 1].createTime;
      } else {
        chatLog = []
      }

      this.getChatLog({userId, afterTime, page, size})
          .then(data => {
            this.chatBoxLoading = false
            call && call(data)
            if (!data.length) return;
            let reverse = data.reverse()
            this.$set(this.chatLogList, userId, [...chatLog, ...reverse])
            this.scrollToEnd()
          });
    },
    handleScrollEnd(event) {
      if (event.target.scrollTop === 0) {
        this.requestBeforeChatLog()
      } else if (event.target.scrollHeight - event.target.scrollTop - event.target.clientHeight === 0) {
        this.requestAfterChatLog()
      }
    },
    scrollToEnd(event) {
      this.$nextTick(() => {
        let scrollbar = this.$refs.scrollbar;
        if (scrollbar && scrollbar.wrap) {
          scrollbar.wrap.scrollTo(0, scrollbar.wrap.scrollHeight)
        }
      })
    },
    sendReplay() {
      let self = this;
      let currentUserId = this.currentUserId;
      this.answerConsulting({userId: currentUserId, content: this.replayInput}).then(() => {
        this.replayInput = "";
        self.requestAfterChatLog()
        this.chatLogList[currentUserId].forEach((chatLog) => {
          chatLog.needHuman = false;
        })
      })
    },
    formatDate(timestamp) {
      return DateUtil.formatDateCommitTimestamp(timestamp);
    },
  },
}
</script>

<template>
  <div class="ConsultingManagement">
    <AppHeader>咨询管理</AppHeader>
    <AppBox class="appBox" id="appBox">
      <div class="tableFilter">
        <el-form :inline="true" :model="filter" size="small" ref="form">
        </el-form>
      </div>
      <XTable
          :api="getUserChatLogOverview"
          :state="consultingList"
          :columns="columns"
          :loading="consultingListLoading"
          tableSize="small"
          :maxHeight="maxHeight"
          :firstColumn="true"
          :layout="layout"
      ></XTable>
    </AppBox>

    <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        @close="closeChatDialog"
    >
      <el-scrollbar id="chat-box" ref="scrollbar" wrap-style="overflow:auto;" style="height: 500px;">
        <div v-for="item in chatLogList[currentUserId]">
          <div style="display: flex;border-bottom: solid 1px gray">
            <div class="user-type">
              <div v-if="item.role==='user'" style="color: #67e199">用户</div>
              <div v-else-if="item.role==='system'||item.role==='assistant'">系统</div>
              <div v-else-if="item.role==='service'">{{ item.answerUser }}</div>
            </div>
            <div style="width: 89%">
              <span style="font-size: 8px">{{ DateUtil.formatDate(item.createTime, "MM-DD HH:mm") }}</span>
              <span style="color: darkred">
                {{ item.needHuman ? "(待回答)" : "" }}
              </span>
              {{ item.content }}
            </div>
          </div>
        </div>
      </el-scrollbar>
      <div style="margin-top: 30px;display: flex" v-if="dialogTitle==='回复'">
        <el-input style="width: 85%;margin-right: 2%" v-model="replayInput" @keyup.enter.native="sendReplay"></el-input>
        <el-button type="primary" @click="sendReplay">发送</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<style scoped lang="scss">
.ConsultingManagement {
  .user-type {
    width: 10%;
    padding-right: 20px;
  }

  .appBox {
    min-height: calc(100vh - 155px);

    .tableFilter {
      padding-bottom: 20px;

      .el-form-item {
        margin-right: 30px;
      }

      ::v-deep .el-range-separator {
        width: 20px !important;
      }
    }

    ::v-deep .el-textarea__inner {
      border: unset;
      height: 65vh;
    }
  }
}
</style>